var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgShare = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 19,
  height: 21,
  viewBox: "0 0 17 21",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M8.97327 0V5.9875H9.10452C3.32952 5.9875 -0.476733 11.8937 0.0482667 17.5375C0.179517 18.5875 0.310767 19.1125 0.310767 19.1125L0.573267 20.425L1.09827 18.7188C2.14827 16.0938 3.72327 13.4688 9.23577 13.6H8.97327V19.85L18.1608 9.79375L8.97327 0ZM10.2858 16.8312V12.4188H9.10452C5.16702 12.4188 2.80452 13.075 0.967017 16.225C1.62327 11.8938 4.51077 7.3 9.10452 7.3H10.2858V3.15L16.192 9.925L10.2858 16.8312Z",
  fill: "black"
})));
export default SvgShare;